export default "__VITE_ASSET__C52QAG7i__"